import QRCode from "qrcode";
import convert from "convert";

const tareInput = document.getElementById("tare-input");
const tareUnit = document.getElementById("tare-unit");
const volumeInput = document.getElementById("volume-input");
const volumeUnit = document.getElementById("volume-unit");
const reuseQRCode = document.getElementById("reuse-qr-code");

function generateReuseCsv(tare, volume) {
  return `REUSE/1.0:${Math.abs(tare)}:${Math.abs(volume)}`;
}

async function generateQR(text) {
  try {
    QRCode.toCanvas(reuseQRCode, text, { margin: 0, mode: "alphanumeric" });
  } catch (error) {
    console.error(error);
  }
}

function updateReuseLabel() {
  const tareValue = parseFloat(tareInput.value) || 0;
  const tareUnitValue = tareUnit.value || "g";
  console.log(tareValue + tareUnitValue);

  const qrTare = convert(tareValue, tareUnitValue).to("g");
  const qrVolume = convert(
    parseFloat(volumeInput.value) || 0,
    volumeUnit.value || "l"
  ).to("l");

  generateQR(generateReuseCsv(qrTare, qrVolume));

  const tareLabelText = convert(tareValue, tareUnit.value)
    .to("best")
    .toString();
  const volumeLabelText = convert(
    parseFloat(volumeInput.value) || 0,
    volumeUnit.value
  )
    .to("best")
    .toString();

  document.getElementById("reuse-qr-label-text-tare").innerText = tareLabelText;
  document.getElementById("reuse-qr-label-text-volume").innerText =
    volumeLabelText;
}

tareInput.addEventListener("change", updateReuseLabel);
tareUnit.addEventListener("change", updateReuseLabel);
volumeInput.addEventListener("change", updateReuseLabel);
volumeUnit.addEventListener("change", updateReuseLabel);
updateReuseLabel();
